import { Beatmap, DatasetInfo } from '../types/beatmap';

// Balanced 100-Card Offline Seed Dataset (Representative Rarity Proportions)
export const SEED_BEATMAPS: Beatmap[] = [
  {
    "id": 2474982,
    "beatmapsetId": 1187609,
    "artist": "Ogura Yui",
    "artistUnicode": "小倉唯",
    "title": "Happiness * Sensation (TV Size)",
    "titleUnicode": "ハピネス*センセーション (TV Size)",
    "version": "Everlasting",
    "creator": "Yuuma",
    "creatorId": 6644401,
    "stars": 4.97,
    "bpm": 170,
    "length": 85,
    "status": "ranked",
    "playcount": 197950,
    "favouriteCount": 71,
    "rankedDate": "2020-12-25T00:22:11Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1187609/covers/cover.jpg?1622190857",
      "card": "https://assets.ppy.sh/beatmaps/1187609/covers/card.jpg?1622190857",
      "list": "https://assets.ppy.sh/beatmaps/1187609/covers/list.jpg?1622190857",
      "slimcover": "https://assets.ppy.sh/beatmaps/1187609/covers/slimcover.jpg?1622190857"
    },
    "previewUrl": "https://b.ppy.sh/preview/1187609.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 3262653,
    "beatmapsetId": 1597580,
    "artist": "Ni-Sokkususu",
    "artistUnicode": "にーそっくすす",
    "title": "Blade Dance (Cut Ver.)",
    "titleUnicode": "精霊剣舞祭 (Cut Ver.)",
    "version": "Xahjinn's Special",
    "creator": "Sajinn",
    "creatorId": 13513687,
    "stars": 5.87,
    "bpm": 187,
    "length": 145,
    "status": "ranked",
    "playcount": 166667,
    "favouriteCount": 92,
    "rankedDate": "2021-11-28T21:01:55Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1597580/covers/cover.jpg?1650710539",
      "card": "https://assets.ppy.sh/beatmaps/1597580/covers/card.jpg?1650710539",
      "list": "https://assets.ppy.sh/beatmaps/1597580/covers/list.jpg?1650710539",
      "slimcover": "https://assets.ppy.sh/beatmaps/1597580/covers/slimcover.jpg?1650710539"
    },
    "previewUrl": "https://b.ppy.sh/preview/1597580.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 4233871,
    "beatmapsetId": 2031329,
    "artist": "Daisuke Ishiwatari feat. Mary Dale Sanchez",
    "artistUnicode": "石渡太輔 feat. Mary Dale Sanchez",
    "title": "Childish killer",
    "titleUnicode": "Childish killer",
    "version": "Jounzan's Extra",
    "creator": "Luscent",
    "creatorId": 2688581,
    "stars": 6.47,
    "bpm": 155,
    "length": 267,
    "status": "ranked",
    "playcount": 114510,
    "favouriteCount": 113,
    "rankedDate": "2023-08-08T02:44:04Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2031329/covers/cover.jpg?1690842340",
      "card": "https://assets.ppy.sh/beatmaps/2031329/covers/card.jpg?1690842340",
      "list": "https://assets.ppy.sh/beatmaps/2031329/covers/list.jpg?1690842340",
      "slimcover": "https://assets.ppy.sh/beatmaps/2031329/covers/slimcover.jpg?1690842340"
    },
    "previewUrl": "https://b.ppy.sh/preview/2031329.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 2955643,
    "beatmapsetId": 1424378,
    "artist": "IGNEA",
    "artistUnicode": "IGNEA",
    "title": "Jahi",
    "titleUnicode": "Jahi",
    "version": "The Sign of Faith",
    "creator": "iamtickrate",
    "creatorId": 10772580,
    "stars": 7.55,
    "bpm": 200,
    "length": 453,
    "status": "ranked",
    "playcount": 39385,
    "favouriteCount": 95,
    "rankedDate": "2023-09-09T21:21:31Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1424378/covers/cover.jpg?1692547782",
      "card": "https://assets.ppy.sh/beatmaps/1424378/covers/card.jpg?1692547782",
      "list": "https://assets.ppy.sh/beatmaps/1424378/covers/list.jpg?1692547782",
      "slimcover": "https://assets.ppy.sh/beatmaps/1424378/covers/slimcover.jpg?1692547782"
    },
    "previewUrl": "https://b.ppy.sh/preview/1424378.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 3889200,
    "beatmapsetId": 1888434,
    "artist": "METAROOM",
    "artistUnicode": "METAROOM",
    "title": "SPIKEY BOI",
    "titleUnicode": "SPIKEY BOI",
    "version": "MUSH (THE FINALE)",
    "creator": "JeZag",
    "creatorId": 3087506,
    "stars": 7.46,
    "bpm": 182,
    "length": 167,
    "status": "loved",
    "playcount": 38125,
    "favouriteCount": 102,
    "rankedDate": "2024-06-14T02:55:17Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1888434/covers/cover.jpg?1671321620",
      "card": "https://assets.ppy.sh/beatmaps/1888434/covers/card.jpg?1671321620",
      "list": "https://assets.ppy.sh/beatmaps/1888434/covers/list.jpg?1671321620",
      "slimcover": "https://assets.ppy.sh/beatmaps/1888434/covers/slimcover.jpg?1671321620"
    },
    "previewUrl": "https://b.ppy.sh/preview/1888434.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 4421600,
    "beatmapsetId": 2107025,
    "artist": "The White Stripes",
    "artistUnicode": "The White Stripes",
    "title": "Fell In Love With A Girl",
    "titleUnicode": "Fell In Love With A Girl",
    "version": "White Blood Cells",
    "creator": "intiaz",
    "creatorId": 6223841,
    "stars": 6.02,
    "bpm": 195,
    "length": 105,
    "status": "ranked",
    "playcount": 18976,
    "favouriteCount": 73,
    "rankedDate": "2026-07-08T16:27:11Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2107025/covers/cover.jpg?1782853031",
      "card": "https://assets.ppy.sh/beatmaps/2107025/covers/card.jpg?1782853031",
      "list": "https://assets.ppy.sh/beatmaps/2107025/covers/list.jpg?1782853031",
      "slimcover": "https://assets.ppy.sh/beatmaps/2107025/covers/slimcover.jpg?1782853031"
    },
    "previewUrl": "https://b.ppy.sh/preview/2107025.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 3946314,
    "beatmapsetId": 1913078,
    "artist": "SYNC.ART'S feat. Rill Practica",
    "artistUnicode": "SYNC.ART'S feat. 桃梨",
    "title": "tod und feuer",
    "titleUnicode": "tod und feuer",
    "version": "Tear and Flame",
    "creator": "Patchouli-R",
    "creatorId": 1061213,
    "stars": 3.17,
    "bpm": 135,
    "length": 301,
    "status": "ranked",
    "playcount": 16543,
    "favouriteCount": 66,
    "rankedDate": "2023-03-09T20:25:18Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1913078/covers/cover.jpg?1676772539",
      "card": "https://assets.ppy.sh/beatmaps/1913078/covers/card.jpg?1676772539",
      "list": "https://assets.ppy.sh/beatmaps/1913078/covers/list.jpg?1676772539",
      "slimcover": "https://assets.ppy.sh/beatmaps/1913078/covers/slimcover.jpg?1676772539"
    },
    "previewUrl": "https://b.ppy.sh/preview/1913078.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 5053677,
    "beatmapsetId": 2348973,
    "artist": "Prico",
    "artistUnicode": "Prico",
    "title": "Doko made mo Tsuzuku Kono Michi o (nenpulse bootleg remix)",
    "titleUnicode": "どこまでも続くこの路を (nenpulse bootleg remix)",
    "version": "Railroad",
    "creator": "Sayama Kaede",
    "creatorId": 4888952,
    "stars": 5.93,
    "bpm": 174,
    "length": 298,
    "status": "ranked",
    "playcount": 13408,
    "favouriteCount": 58,
    "rankedDate": "2025-06-10T08:46:17Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2348973/covers/cover.jpg?1749277132",
      "card": "https://assets.ppy.sh/beatmaps/2348973/covers/card.jpg?1749277132",
      "list": "https://assets.ppy.sh/beatmaps/2348973/covers/list.jpg?1749277132",
      "slimcover": "https://assets.ppy.sh/beatmaps/2348973/covers/slimcover.jpg?1749277132"
    },
    "previewUrl": "https://b.ppy.sh/preview/2348973.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 4987934,
    "beatmapsetId": 2326752,
    "artist": "Kano",
    "artistUnicode": "鹿乃",
    "title": "ai to ai",
    "titleUnicode": "愛と哀",
    "version": "Insane",
    "creator": "bucky",
    "creatorId": 6750761,
    "stars": 4.97,
    "bpm": 168,
    "length": 227,
    "status": "ranked",
    "playcount": 10481,
    "favouriteCount": 51,
    "rankedDate": "2025-04-08T20:02:04Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2326752/covers/cover.jpg?1743534562",
      "card": "https://assets.ppy.sh/beatmaps/2326752/covers/card.jpg?1743534562",
      "list": "https://assets.ppy.sh/beatmaps/2326752/covers/list.jpg?1743534562",
      "slimcover": "https://assets.ppy.sh/beatmaps/2326752/covers/slimcover.jpg?1743534562"
    },
    "previewUrl": "https://b.ppy.sh/preview/2326752.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 3685262,
    "beatmapsetId": 1797810,
    "artist": "JEREMIAS",
    "artistUnicode": "JEREMIAS",
    "title": "hdl",
    "titleUnicode": "hdl",
    "version": "hab dich lieb",
    "creator": "Le Mirai",
    "creatorId": 13646997,
    "stars": 4.66,
    "bpm": 132,
    "length": 149,
    "status": "ranked",
    "playcount": 9265,
    "favouriteCount": 47,
    "rankedDate": "2026-01-07T16:05:15Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1797810/covers/cover.jpg?1767195986",
      "card": "https://assets.ppy.sh/beatmaps/1797810/covers/card.jpg?1767195986",
      "list": "https://assets.ppy.sh/beatmaps/1797810/covers/list.jpg?1767195986",
      "slimcover": "https://assets.ppy.sh/beatmaps/1797810/covers/slimcover.jpg?1767195986"
    },
    "previewUrl": "https://b.ppy.sh/preview/1797810.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 4931544,
    "beatmapsetId": 2306198,
    "artist": "AK Liu Zhang",
    "artistUnicode": "AK 刘彰",
    "title": "Lull (TV Size)",
    "titleUnicode": "Lull (TV Size)",
    "version": "Requiem",
    "creator": "[ Drop ]",
    "creatorId": 2391299,
    "stars": 4.64,
    "bpm": 73,
    "length": 118,
    "status": "ranked",
    "playcount": 6301,
    "favouriteCount": 36,
    "rankedDate": "2026-03-10T18:25:28Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2306198/covers/cover.jpg?1772560104",
      "card": "https://assets.ppy.sh/beatmaps/2306198/covers/card.jpg?1772560104",
      "list": "https://assets.ppy.sh/beatmaps/2306198/covers/list.jpg?1772560104",
      "slimcover": "https://assets.ppy.sh/beatmaps/2306198/covers/slimcover.jpg?1772560104"
    },
    "previewUrl": "https://b.ppy.sh/preview/2306198.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 4845976,
    "beatmapsetId": 2274424,
    "artist": "Camel",
    "artistUnicode": "Camel",
    "title": "Freefall",
    "titleUnicode": "Freefall",
    "version": "Mirage",
    "creator": "SaltyLucario",
    "creatorId": 6571670,
    "stars": 6.12,
    "bpm": 136,
    "length": 348,
    "status": "ranked",
    "playcount": 2002,
    "favouriteCount": 17,
    "rankedDate": "2025-04-05T21:42:59Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2274424/covers/cover.jpg?1743263146",
      "card": "https://assets.ppy.sh/beatmaps/2274424/covers/card.jpg?1743263146",
      "list": "https://assets.ppy.sh/beatmaps/2274424/covers/list.jpg?1743263146",
      "slimcover": "https://assets.ppy.sh/beatmaps/2274424/covers/slimcover.jpg?1743263146"
    },
    "previewUrl": "https://b.ppy.sh/preview/2274424.mp3",
    "rarity": "Common",
    "popularityScore": 42.71,
    "mode": 0
  },
  {
    "id": 2320634,
    "beatmapsetId": 1110601,
    "artist": "Duca",
    "artistUnicode": "Duca",
    "title": "I'm in the side",
    "titleUnicode": "I'm in the side",
    "version": "Promise",
    "creator": "Bellicose",
    "creatorId": 4298072,
    "stars": 6.35,
    "bpm": 180,
    "length": 246,
    "status": "ranked",
    "playcount": 194670,
    "favouriteCount": 73,
    "rankedDate": "2020-04-10T14:03:08Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1110601/covers/cover.jpg?1650693248",
      "card": "https://assets.ppy.sh/beatmaps/1110601/covers/card.jpg?1650693248",
      "list": "https://assets.ppy.sh/beatmaps/1110601/covers/list.jpg?1650693248",
      "slimcover": "https://assets.ppy.sh/beatmaps/1110601/covers/slimcover.jpg?1650693248"
    },
    "previewUrl": "https://b.ppy.sh/preview/1110601.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 1600023,
    "beatmapsetId": 760860,
    "artist": "OKAMOTO'S",
    "title": "HEADHUNT (TV Size)",
    "version": "Insane",
    "creator": "Milan-",
    "stars": 4.48,
    "bpm": 160,
    "length": 87,
    "status": "ranked",
    "playcount": 162549,
    "favouriteCount": 114,
    "rankedDate": "2018-06-25T06:40:06Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/760860/covers/cover.jpg?1650663242",
      "card": "https://assets.ppy.sh/beatmaps/760860/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/760860/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/760860/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/760860.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 1166986,
    "beatmapsetId": 550891,
    "artist": "Aimer",
    "artistUnicode": "Aimer",
    "title": "everlasting snow",
    "titleUnicode": "everlasting snow",
    "version": "Eternal",
    "creator": "SeaRasp",
    "creatorId": 4789626,
    "stars": 4.22,
    "bpm": 76,
    "length": 324,
    "status": "ranked",
    "playcount": 97144,
    "favouriteCount": 128,
    "rankedDate": "2017-02-04T05:20:07Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/550891/covers/cover.jpg?1622113017",
      "card": "https://assets.ppy.sh/beatmaps/550891/covers/card.jpg?1622113017",
      "list": "https://assets.ppy.sh/beatmaps/550891/covers/list.jpg?1622113017",
      "slimcover": "https://assets.ppy.sh/beatmaps/550891/covers/slimcover.jpg?1622113017"
    },
    "previewUrl": "https://b.ppy.sh/preview/550891.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 4713876,
    "beatmapsetId": 2223025,
    "artist": "vrif",
    "artistUnicode": "vrif",
    "title": "SOUR @vrif250",
    "titleUnicode": "SOUR @vrif250",
    "version": "why would the artist name the song like 3 months after bro",
    "creator": "[-Evil-]",
    "creatorId": 10234313,
    "stars": 6.52,
    "bpm": 163,
    "length": 94,
    "status": "ranked",
    "playcount": 81870,
    "favouriteCount": 118,
    "rankedDate": "2025-01-21T20:25:46Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2223025/covers/cover.jpg?1736860268",
      "card": "https://assets.ppy.sh/beatmaps/2223025/covers/card.jpg?1736860268",
      "list": "https://assets.ppy.sh/beatmaps/2223025/covers/list.jpg?1736860268",
      "slimcover": "https://assets.ppy.sh/beatmaps/2223025/covers/slimcover.jpg?1736860268"
    },
    "previewUrl": "https://b.ppy.sh/preview/2223025.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 3031713,
    "beatmapsetId": 1477697,
    "artist": "Ax feat. Yoko Natsukawa",
    "artistUnicode": "Ax feat. 夏川陽子",
    "title": "Sakimori Renka",
    "titleUnicode": "防人恋歌",
    "version": "Expert",
    "creator": "Jycool",
    "creatorId": 1546760,
    "stars": 4.87,
    "bpm": 170,
    "length": 113,
    "status": "ranked",
    "playcount": 73777,
    "favouriteCount": 117,
    "rankedDate": "2021-12-21T21:05:16Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1477697/covers/cover.jpg?1639372059",
      "card": "https://assets.ppy.sh/beatmaps/1477697/covers/card.jpg?1639372059",
      "list": "https://assets.ppy.sh/beatmaps/1477697/covers/list.jpg?1639372059",
      "slimcover": "https://assets.ppy.sh/beatmaps/1477697/covers/slimcover.jpg?1639372059"
    },
    "previewUrl": "https://b.ppy.sh/preview/1477697.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 4761724,
    "beatmapsetId": 2227458,
    "artist": "Junk",
    "artistUnicode": "Junk",
    "title": "Kagaribi",
    "titleUnicode": "Kagaribi",
    "version": "PaRaDogi's Expert",
    "creator": "-kevincela-",
    "creatorId": 266596,
    "stars": 5.89,
    "bpm": 144,
    "length": 130,
    "status": "ranked",
    "playcount": 64266,
    "favouriteCount": 115,
    "rankedDate": "2024-12-30T00:21:58Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2227458/covers/cover.jpg?1734894063",
      "card": "https://assets.ppy.sh/beatmaps/2227458/covers/card.jpg?1734894063",
      "list": "https://assets.ppy.sh/beatmaps/2227458/covers/list.jpg?1734894063",
      "slimcover": "https://assets.ppy.sh/beatmaps/2227458/covers/slimcover.jpg?1734894063"
    },
    "previewUrl": "https://b.ppy.sh/preview/2227458.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 2055091,
    "beatmapsetId": 981935,
    "artist": "SawanoHiroyuki[nZk]",
    "artistUnicode": "SawanoHiroyuki[nZk]",
    "title": "REMEMBER",
    "titleUnicode": "REMEMBER",
    "version": "Collab",
    "creator": "tomadoi",
    "creatorId": 5712451,
    "stars": 5.05,
    "bpm": 96,
    "length": 303,
    "status": "ranked",
    "playcount": 45135,
    "favouriteCount": 110,
    "rankedDate": "2019-11-02T05:01:17Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/981935/covers/cover.jpg?1622163310",
      "card": "https://assets.ppy.sh/beatmaps/981935/covers/card.jpg?1622163310",
      "list": "https://assets.ppy.sh/beatmaps/981935/covers/list.jpg?1622163310",
      "slimcover": "https://assets.ppy.sh/beatmaps/981935/covers/slimcover.jpg?1622163310"
    },
    "previewUrl": "https://b.ppy.sh/preview/981935.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 867801,
    "beatmapsetId": 399140,
    "artist": "lily white",
    "artistUnicode": "lily white",
    "title": "Futari Happiness",
    "titleUnicode": "ふたりハピネス",
    "version": "Aeonian Friendship",
    "creator": "Baraatje123",
    "creatorId": 2533040,
    "stars": 2.48,
    "bpm": 78,
    "length": 361,
    "status": "ranked",
    "playcount": 36066,
    "favouriteCount": 99,
    "rankedDate": "2016-01-30T15:00:07Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/399140/covers/cover.jpg?1622098253",
      "card": "https://assets.ppy.sh/beatmaps/399140/covers/card.jpg?1622098253",
      "list": "https://assets.ppy.sh/beatmaps/399140/covers/list.jpg?1622098253",
      "slimcover": "https://assets.ppy.sh/beatmaps/399140/covers/slimcover.jpg?1622098253"
    },
    "previewUrl": "https://b.ppy.sh/preview/399140.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 4703018,
    "beatmapsetId": 2218754,
    "artist": "toby fox",
    "artistUnicode": "toby fox",
    "title": "Home (Omekyu Piano Cover)",
    "titleUnicode": "Home (Omekyu Piano Cover)",
    "version": "Despite everything, it's still you.",
    "creator": "Omekyu",
    "creatorId": 14348073,
    "stars": 2.37,
    "bpm": 77,
    "length": 141,
    "status": "ranked",
    "playcount": 6572,
    "favouriteCount": 37,
    "rankedDate": "2025-01-18T08:23:18Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2218754/covers/cover.jpg?1736554980",
      "card": "https://assets.ppy.sh/beatmaps/2218754/covers/card.jpg?1736554980",
      "list": "https://assets.ppy.sh/beatmaps/2218754/covers/list.jpg?1736554980",
      "slimcover": "https://assets.ppy.sh/beatmaps/2218754/covers/slimcover.jpg?1736554980"
    },
    "previewUrl": "https://b.ppy.sh/preview/2218754.mp3",
    "rarity": "Common",
    "popularityScore": 42.7,
    "mode": 0
  },
  {
    "id": 1445924,
    "beatmapsetId": 676178,
    "artist": "Jennifer Karr",
    "artistUnicode": "Jennifer Karr",
    "title": "My Life As A Teenage Robot",
    "titleUnicode": "My Life As A Teenage Robot",
    "version": "Voli's Extreme",
    "creator": "HydroCannon13",
    "creatorId": 5425046,
    "stars": 4.93,
    "bpm": 171,
    "length": 33,
    "status": "ranked",
    "playcount": 217071,
    "favouriteCount": 78,
    "rankedDate": "2018-04-23T13:20:32Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/676178/covers/cover.jpg?1650655157",
      "card": "https://assets.ppy.sh/beatmaps/676178/covers/card.jpg?1650655157",
      "list": "https://assets.ppy.sh/beatmaps/676178/covers/list.jpg?1650655157",
      "slimcover": "https://assets.ppy.sh/beatmaps/676178/covers/slimcover.jpg?1650655157"
    },
    "previewUrl": "https://b.ppy.sh/preview/676178.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 21729,
    "beatmapsetId": 3425,
    "artist": "GARDEN",
    "artistUnicode": "GARDEN",
    "title": "Advance Adventure",
    "titleUnicode": "Advance Adventure",
    "version": "Hard",
    "creator": "luke0719",
    "creatorId": 14583,
    "stars": 3.34,
    "bpm": 168,
    "length": 147,
    "status": "ranked",
    "playcount": 180542,
    "favouriteCount": 87,
    "rankedDate": "2008-10-12T11:02:39Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/3425/covers/cover.jpg?1622020883",
      "card": "https://assets.ppy.sh/beatmaps/3425/covers/card.jpg?1622020883",
      "list": "https://assets.ppy.sh/beatmaps/3425/covers/list.jpg?1622020883",
      "slimcover": "https://assets.ppy.sh/beatmaps/3425/covers/slimcover.jpg?1622020883"
    },
    "previewUrl": "https://b.ppy.sh/preview/3425.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 3792984,
    "beatmapsetId": 1846448,
    "artist": "Dragon Guardian",
    "artistUnicode": "Dragon Guardian",
    "title": "Tsuioku no Kuroki Makenshi",
    "titleUnicode": "追憶の黒き魔剣士",
    "version": "Fate",
    "creator": "lit120",
    "creatorId": 3109248,
    "stars": 7.97,
    "bpm": 190,
    "length": 302,
    "status": "ranked",
    "playcount": 103564,
    "favouriteCount": 113,
    "rankedDate": "2022-10-05T16:25:07Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1846448/covers/cover.jpg?1663935715",
      "card": "https://assets.ppy.sh/beatmaps/1846448/covers/card.jpg?1663935715",
      "list": "https://assets.ppy.sh/beatmaps/1846448/covers/list.jpg?1663935715",
      "slimcover": "https://assets.ppy.sh/beatmaps/1846448/covers/slimcover.jpg?1663935715"
    },
    "previewUrl": "https://b.ppy.sh/preview/1846448.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 4924390,
    "beatmapsetId": 2303793,
    "artist": "Leo/need x Hatsune Miku",
    "artistUnicode": "Leo/need × 初音ミク",
    "title": "Lost and Found (Game Ver.)",
    "titleUnicode": "ロストエンファウンド (Game Ver.)",
    "version": "Found",
    "creator": "Dailycare",
    "creatorId": 1634445,
    "stars": 6.96,
    "bpm": 184,
    "length": 136,
    "status": "ranked",
    "playcount": 30388,
    "favouriteCount": 91,
    "rankedDate": "2025-05-08T20:03:05Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2303793/covers/cover.jpg?1743855330",
      "card": "https://assets.ppy.sh/beatmaps/2303793/covers/card.jpg?1743855330",
      "list": "https://assets.ppy.sh/beatmaps/2303793/covers/list.jpg?1743855330",
      "slimcover": "https://assets.ppy.sh/beatmaps/2303793/covers/slimcover.jpg?1743855330"
    },
    "previewUrl": "https://b.ppy.sh/preview/2303793.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 4547760,
    "beatmapsetId": 2157319,
    "artist": "Infected Mushroom",
    "artistUnicode": "Infected Mushroom",
    "title": "Now is Gold (feat. Kelsy Karter)",
    "titleUnicode": "Now is Gold (feat. Kelsy Karter)",
    "version": "Golden",
    "creator": "Nemis",
    "creatorId": 1635091,
    "stars": 5.57,
    "bpm": 140,
    "length": 355,
    "status": "ranked",
    "playcount": 15958,
    "favouriteCount": 63,
    "rankedDate": "2024-04-09T20:24:43Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2157319/covers/cover.jpg?1712057900",
      "card": "https://assets.ppy.sh/beatmaps/2157319/covers/card.jpg?1712057900",
      "list": "https://assets.ppy.sh/beatmaps/2157319/covers/list.jpg?1712057900",
      "slimcover": "https://assets.ppy.sh/beatmaps/2157319/covers/slimcover.jpg?1712057900"
    },
    "previewUrl": "https://b.ppy.sh/preview/2157319.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 5200395,
    "beatmapsetId": 2399389,
    "artist": "BIGBANG",
    "artistUnicode": "BIGBANG",
    "title": "LET'S NOT FALL IN LOVE",
    "titleUnicode": "우리 사랑하지 말아요",
    "version": "Syph & Kyouren's Insane",
    "creator": "Syph",
    "creatorId": 4858573,
    "stars": 4.22,
    "bpm": 125,
    "length": 208,
    "status": "ranked",
    "playcount": 6840,
    "favouriteCount": 38,
    "rankedDate": "2025-07-27T00:06:03Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2399389/covers/cover.jpg?1752875158",
      "card": "https://assets.ppy.sh/beatmaps/2399389/covers/card.jpg?1752875158",
      "list": "https://assets.ppy.sh/beatmaps/2399389/covers/list.jpg?1752875158",
      "slimcover": "https://assets.ppy.sh/beatmaps/2399389/covers/slimcover.jpg?1752875158"
    },
    "previewUrl": "https://b.ppy.sh/preview/2399389.mp3",
    "rarity": "Common",
    "popularityScore": 42.69,
    "mode": 0
  },
  {
    "id": 2973389,
    "beatmapsetId": 1445593,
    "artist": "mer",
    "artistUnicode": "メル",
    "title": "Golden Journey",
    "titleUnicode": "ゴールデンジャーニー",
    "version": "Sparkle of Youth",
    "creator": "KeyWee",
    "creatorId": 10476879,
    "stars": 5.26,
    "bpm": 178,
    "length": 253,
    "status": "ranked",
    "playcount": 103466,
    "favouriteCount": 116,
    "rankedDate": "2021-07-14T08:02:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1445593/covers/cover.jpg?1625460160",
      "card": "https://assets.ppy.sh/beatmaps/1445593/covers/card.jpg?1625460160",
      "list": "https://assets.ppy.sh/beatmaps/1445593/covers/list.jpg?1625460160",
      "slimcover": "https://assets.ppy.sh/beatmaps/1445593/covers/slimcover.jpg?1625460160"
    },
    "previewUrl": "https://b.ppy.sh/preview/1445593.mp3",
    "rarity": "Common",
    "popularityScore": 42.68,
    "mode": 0
  },
  {
    "id": 3794459,
    "beatmapsetId": 1847159,
    "artist": "Mitchie M",
    "artistUnicode": "Mitchie M",
    "title": "Amazing Magician",
    "titleUnicode": "アメイジングマジシャン",
    "version": "Magic",
    "creator": "Amateurre",
    "creatorId": 7326908,
    "stars": 5.57,
    "bpm": 165,
    "length": 207,
    "status": "ranked",
    "playcount": 87043,
    "favouriteCount": 118,
    "rankedDate": "2022-09-30T11:43:00Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1847159/covers/cover.jpg?1663901359",
      "card": "https://assets.ppy.sh/beatmaps/1847159/covers/card.jpg?1663901359",
      "list": "https://assets.ppy.sh/beatmaps/1847159/covers/list.jpg?1663901359",
      "slimcover": "https://assets.ppy.sh/beatmaps/1847159/covers/slimcover.jpg?1663901359"
    },
    "previewUrl": "https://b.ppy.sh/preview/1847159.mp3",
    "rarity": "Common",
    "popularityScore": 42.68,
    "mode": 0
  },
  {
    "id": 2628436,
    "beatmapsetId": 1264630,
    "artist": "Hirose Kohmi",
    "artistUnicode": "広瀬香美",
    "title": "Groovy! (TV Size)",
    "titleUnicode": "Groovy! (TV Size)",
    "version": "Insane",
    "creator": "bossandy",
    "creatorId": 360437,
    "stars": 3.28,
    "bpm": 123,
    "length": 68,
    "status": "ranked",
    "playcount": 86250,
    "favouriteCount": 118,
    "rankedDate": "2020-10-19T17:45:00Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1264630/covers/cover.jpg?1622198171",
      "card": "https://assets.ppy.sh/beatmaps/1264630/covers/card.jpg?1622198171",
      "list": "https://assets.ppy.sh/beatmaps/1264630/covers/list.jpg?1622198171",
      "slimcover": "https://assets.ppy.sh/beatmaps/1264630/covers/slimcover.jpg?1622198171"
    },
    "previewUrl": "https://b.ppy.sh/preview/1264630.mp3",
    "rarity": "Common",
    "popularityScore": 42.68,
    "mode": 0
  },
  {
    "id": 3325727,
    "beatmapsetId": 1629102,
    "artist": "Inori Minase",
    "artistUnicode": "水瀬いのり",
    "title": "Snow White",
    "titleUnicode": "Snow White",
    "version": "Dreams",
    "creator": "Wen",
    "creatorId": 5210848,
    "stars": 5.05,
    "bpm": 155,
    "length": 234,
    "status": "ranked",
    "playcount": 73984,
    "favouriteCount": 117,
    "rankedDate": "2021-12-08T19:23:02Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1629102/covers/cover.jpg?1638379119",
      "card": "https://assets.ppy.sh/beatmaps/1629102/covers/card.jpg?1638379119",
      "list": "https://assets.ppy.sh/beatmaps/1629102/covers/list.jpg?1638379119",
      "slimcover": "https://assets.ppy.sh/beatmaps/1629102/covers/slimcover.jpg?1638379119"
    },
    "previewUrl": "https://b.ppy.sh/preview/1629102.mp3",
    "rarity": "Common",
    "popularityScore": 42.68,
    "mode": 0
  },
  {
    "id": 5633207,
    "beatmapsetId": 2537245,
    "artist": "KINEMA106",
    "artistUnicode": "キネマ106",
    "title": "Kurui Saku Sakura",
    "titleUnicode": "狂イ咲ク桜",
    "version": "Kagome",
    "creator": "Sayame",
    "creatorId": 30409296,
    "stars": 6.54,
    "bpm": 188,
    "length": 192,
    "status": "ranked",
    "playcount": 37154,
    "favouriteCount": 186,
    "rankedDate": "2026-06-08T15:25:44Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2537245/covers/cover.jpg?1780298664",
      "card": "https://assets.ppy.sh/beatmaps/2537245/covers/card.jpg?1780298664",
      "list": "https://assets.ppy.sh/beatmaps/2537245/covers/list.jpg?1780298664",
      "slimcover": "https://assets.ppy.sh/beatmaps/2537245/covers/slimcover.jpg?1780298664"
    },
    "previewUrl": "https://b.ppy.sh/preview/2537245.mp3",
    "rarity": "Uncommon",
    "popularityScore": 56.01,
    "mode": 0
  },
  {
    "id": 78350,
    "beatmapsetId": 20266,
    "artist": "_yoc feat. Sara Matsumoto",
    "artistUnicode": "_yoc feat. Sara Matsumoto",
    "title": "Moonlight Windia",
    "titleUnicode": "Moonlight Windia",
    "version": "happy30",
    "creator": "ouranhshc",
    "creatorId": 139493,
    "stars": 4.21,
    "bpm": 153,
    "length": 235,
    "status": "ranked",
    "playcount": 432034,
    "favouriteCount": 96,
    "rankedDate": "2010-12-03T12:00:58Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/20266/covers/cover.jpg?1622039539",
      "card": "https://assets.ppy.sh/beatmaps/20266/covers/card.jpg?1622039539",
      "list": "https://assets.ppy.sh/beatmaps/20266/covers/list.jpg?1622039539",
      "slimcover": "https://assets.ppy.sh/beatmaps/20266/covers/slimcover.jpg?1622039539"
    },
    "previewUrl": "https://b.ppy.sh/preview/20266.mp3",
    "rarity": "Uncommon",
    "popularityScore": 56,
    "mode": 0
  },
  {
    "id": 2771124,
    "beatmapsetId": 1337747,
    "artist": "IVOXYGEN",
    "title": "Young Kid",
    "version": "Hard",
    "creator": "Kinglit_VX",
    "stars": 4.65,
    "bpm": 150,
    "length": 102,
    "status": "graveyard",
    "playcount": 410032,
    "favouriteCount": 140,
    "rankedDate": "2021-01-01T23:40:39Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1337747/covers/cover.jpg?1772520853",
      "card": "https://assets.ppy.sh/beatmaps/1337747/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/1337747/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/1337747/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/1337747.mp3",
    "rarity": "Uncommon",
    "popularityScore": 56,
    "mode": 0
  },
  {
    "id": 4062781,
    "beatmapsetId": 1960479,
    "artist": "HOYO-MiX",
    "artistUnicode": "HOYO-MiX",
    "title": "Surreal Noctivaga",
    "titleUnicode": "此夕星游",
    "version": "Dream of the Star-Stream Shaker",
    "creator": "Soraka",
    "creatorId": 16711065,
    "stars": 5.32,
    "bpm": 111,
    "length": 62,
    "status": "ranked",
    "playcount": 105527,
    "favouriteCount": 205,
    "rankedDate": "2023-05-01T19:25:11Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1960479/covers/cover.jpg?1682341836",
      "card": "https://assets.ppy.sh/beatmaps/1960479/covers/card.jpg?1682341836",
      "list": "https://assets.ppy.sh/beatmaps/1960479/covers/list.jpg?1682341836",
      "slimcover": "https://assets.ppy.sh/beatmaps/1960479/covers/slimcover.jpg?1682341836"
    },
    "previewUrl": "https://b.ppy.sh/preview/1960479.mp3",
    "rarity": "Uncommon",
    "popularityScore": 56,
    "mode": 0
  },
  {
    "id": 3469691,
    "beatmapsetId": 1698203,
    "artist": "Ayunda Risu",
    "artistUnicode": "アユンダ・リス",
    "title": "ALiCE&u",
    "titleUnicode": "ALiCE&u",
    "version": "Timeless Song That Carry All the Wish",
    "creator": "Nevertary",
    "creatorId": 7202957,
    "stars": 4.69,
    "bpm": 170,
    "length": 258,
    "status": "ranked",
    "playcount": 45649,
    "favouriteCount": 189,
    "rankedDate": "2022-02-27T18:45:02Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1698203/covers/cover.jpg?1645326825",
      "card": "https://assets.ppy.sh/beatmaps/1698203/covers/card.jpg?1645326825",
      "list": "https://assets.ppy.sh/beatmaps/1698203/covers/list.jpg?1645326825",
      "slimcover": "https://assets.ppy.sh/beatmaps/1698203/covers/slimcover.jpg?1645326825"
    },
    "previewUrl": "https://b.ppy.sh/preview/1698203.mp3",
    "rarity": "Uncommon",
    "popularityScore": 56,
    "mode": 0
  },
  {
    "id": 1685444,
    "beatmapsetId": 802930,
    "artist": "LIQU@.",
    "artistUnicode": "LIQU@。",
    "title": "NANAIRO",
    "titleUnicode": "NANAIRO",
    "version": "Breakdown",
    "creator": "lcfc",
    "creatorId": 7322726,
    "stars": 6.33,
    "bpm": 192,
    "length": 113,
    "status": "ranked",
    "playcount": 477927,
    "favouriteCount": 107,
    "rankedDate": "2018-08-30T18:40:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/802930/covers/cover.jpg?1650665931",
      "card": "https://assets.ppy.sh/beatmaps/802930/covers/card.jpg?1650665931",
      "list": "https://assets.ppy.sh/beatmaps/802930/covers/list.jpg?1650665931",
      "slimcover": "https://assets.ppy.sh/beatmaps/802930/covers/slimcover.jpg?1650665931"
    },
    "previewUrl": "https://b.ppy.sh/preview/802930.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.99,
    "mode": 0
  },
  {
    "id": 66535,
    "beatmapsetId": 18689,
    "artist": "Anamanaguchi",
    "artistUnicode": "Anamanaguchi",
    "title": "My Skateboard Will Go On",
    "titleUnicode": "My Skateboard Will Go On",
    "version": "Insane",
    "creator": "Sushi",
    "creatorId": 43108,
    "stars": 4.44,
    "bpm": 192,
    "length": 191,
    "status": "ranked",
    "playcount": 285787,
    "favouriteCount": 158,
    "rankedDate": "2010-08-10T22:57:42Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/18689/covers/cover.jpg?1622038316",
      "card": "https://assets.ppy.sh/beatmaps/18689/covers/card.jpg?1622038316",
      "list": "https://assets.ppy.sh/beatmaps/18689/covers/list.jpg?1622038316",
      "slimcover": "https://assets.ppy.sh/beatmaps/18689/covers/slimcover.jpg?1622038316"
    },
    "previewUrl": "https://b.ppy.sh/preview/18689.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.99,
    "mode": 0
  },
  {
    "id": 2295145,
    "beatmapsetId": 1098516,
    "artist": "Ayano Mashiro",
    "artistUnicode": "綾野ましろ",
    "title": "Alive",
    "titleUnicode": "Alive",
    "version": "Resilience",
    "creator": "tomadoi",
    "creatorId": 5712451,
    "stars": 5.45,
    "bpm": 182,
    "length": 225,
    "status": "ranked",
    "playcount": 107571,
    "favouriteCount": 205,
    "rankedDate": "2021-06-16T18:06:32Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1098516/covers/cover.jpg?1623206686",
      "card": "https://assets.ppy.sh/beatmaps/1098516/covers/card.jpg?1623206686",
      "list": "https://assets.ppy.sh/beatmaps/1098516/covers/list.jpg?1623206686",
      "slimcover": "https://assets.ppy.sh/beatmaps/1098516/covers/slimcover.jpg?1623206686"
    },
    "previewUrl": "https://b.ppy.sh/preview/1098516.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.99,
    "mode": 0
  },
  {
    "id": 5272112,
    "beatmapsetId": 2412316,
    "artist": "MetaHumanBoi",
    "artistUnicode": "MetaHumanBoi",
    "title": "kinetic flux",
    "titleUnicode": "kinetic flux",
    "version": "Expert",
    "creator": "mintIceCream_",
    "creatorId": 13221589,
    "stars": 6.34,
    "bpm": 162,
    "length": 185,
    "status": "ranked",
    "playcount": 50505,
    "favouriteCount": 192,
    "rankedDate": "2025-12-22T22:07:34Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2412316/covers/cover.jpg?1765822589",
      "card": "https://assets.ppy.sh/beatmaps/2412316/covers/card.jpg?1765822589",
      "list": "https://assets.ppy.sh/beatmaps/2412316/covers/list.jpg?1765822589",
      "slimcover": "https://assets.ppy.sh/beatmaps/2412316/covers/slimcover.jpg?1765822589"
    },
    "previewUrl": "https://b.ppy.sh/preview/2412316.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.99,
    "mode": 0
  },
  {
    "id": 371645,
    "beatmapsetId": 150571,
    "artist": "Ray",
    "artistUnicode": "Ray",
    "title": "lull ~Soshite Bokura wa~ (TV Size)",
    "titleUnicode": "lull～そして僕らは～ (TV Size)",
    "version": "Melo's Insane",
    "creator": "Andrea",
    "creatorId": 33599,
    "stars": 3.53,
    "bpm": 133,
    "length": 88,
    "status": "ranked",
    "playcount": 488843,
    "favouriteCount": 102,
    "rankedDate": "2014-03-17T14:42:24Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/150571/covers/cover.jpg?1650620676",
      "card": "https://assets.ppy.sh/beatmaps/150571/covers/card.jpg?1650620676",
      "list": "https://assets.ppy.sh/beatmaps/150571/covers/list.jpg?1650620676",
      "slimcover": "https://assets.ppy.sh/beatmaps/150571/covers/slimcover.jpg?1650620676"
    },
    "previewUrl": "https://b.ppy.sh/preview/150571.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 139603,
    "beatmapsetId": 32369,
    "artist": "Basic Element",
    "artistUnicode": "Basic Element",
    "title": "Touch You Right Now",
    "titleUnicode": "Touch You Right Now",
    "version": "Insane",
    "creator": "Kiiwa",
    "creatorId": 231111,
    "stars": 4.24,
    "bpm": 129,
    "length": 187,
    "status": "ranked",
    "playcount": 344373,
    "favouriteCount": 160,
    "rankedDate": "2012-09-15T09:23:43Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/32369/covers/cover.jpg?1650610661",
      "card": "https://assets.ppy.sh/beatmaps/32369/covers/card.jpg?1650610661",
      "list": "https://assets.ppy.sh/beatmaps/32369/covers/list.jpg?1650610661",
      "slimcover": "https://assets.ppy.sh/beatmaps/32369/covers/slimcover.jpg?1650610661"
    },
    "previewUrl": "https://b.ppy.sh/preview/32369.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 1680868,
    "beatmapsetId": 800640,
    "artist": "Camellia",
    "artistUnicode": "かめりあ",
    "title": "DON'T GIVE A FUCK",
    "titleUnicode": "DON'T GIVE A FUCK",
    "version": "unhappy",
    "creator": "z1085684963",
    "creatorId": 1816779,
    "stars": 6.69,
    "bpm": 128,
    "length": 300,
    "status": "ranked",
    "playcount": 175536,
    "favouriteCount": 219,
    "rankedDate": "2019-02-27T07:40:04Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/800640/covers/cover.jpg?1622142027",
      "card": "https://assets.ppy.sh/beatmaps/800640/covers/card.jpg?1622142027",
      "list": "https://assets.ppy.sh/beatmaps/800640/covers/list.jpg?1622142027",
      "slimcover": "https://assets.ppy.sh/beatmaps/800640/covers/slimcover.jpg?1622142027"
    },
    "previewUrl": "https://b.ppy.sh/preview/800640.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 2736744,
    "beatmapsetId": 1321114,
    "artist": "Pizuya's Cell feat. Futoumeido",
    "artistUnicode": "ぴずやの独房 feat. 普透明度",
    "title": "NOiSE",
    "titleUnicode": "NOiSE -ノイズ-",
    "version": "Collab Extra",
    "creator": "SuperBox",
    "creatorId": 4783121,
    "stars": 7.17,
    "bpm": 203,
    "length": 299,
    "status": "ranked",
    "playcount": 165936,
    "favouriteCount": 192,
    "rankedDate": "2021-10-22T17:43:29Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1321114/covers/cover.jpg?1634274489",
      "card": "https://assets.ppy.sh/beatmaps/1321114/covers/card.jpg?1634274489",
      "list": "https://assets.ppy.sh/beatmaps/1321114/covers/list.jpg?1634274489",
      "slimcover": "https://assets.ppy.sh/beatmaps/1321114/covers/slimcover.jpg?1634274489"
    },
    "previewUrl": "https://b.ppy.sh/preview/1321114.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 4461967,
    "beatmapsetId": 2123244,
    "artist": "Saor",
    "artistUnicode": "Saor",
    "title": "Forgotten Paths",
    "titleUnicode": "Forgotten Paths",
    "version": "Hymn of the Forest",
    "creator": "nebuwua",
    "creatorId": 14729352,
    "stars": 6.41,
    "bpm": 175,
    "length": 610,
    "status": "ranked",
    "playcount": 39997,
    "favouriteCount": 170,
    "rankedDate": "2025-02-14T00:01:56Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2123244/covers/cover.jpg?1738885172",
      "card": "https://assets.ppy.sh/beatmaps/2123244/covers/card.jpg?1738885172",
      "list": "https://assets.ppy.sh/beatmaps/2123244/covers/list.jpg?1738885172",
      "slimcover": "https://assets.ppy.sh/beatmaps/2123244/covers/slimcover.jpg?1738885172"
    },
    "previewUrl": "https://b.ppy.sh/preview/2123244.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 4920005,
    "beatmapsetId": 2302059,
    "artist": "HyuN feat. Sennzai",
    "artistUnicode": "HyuN feat. Sennzai",
    "title": "Duplicity Shade",
    "titleUnicode": "Duplicity Shade",
    "version": "The Glimpses of Light from a Piece of Broken Glass",
    "creator": "Nevertary",
    "creatorId": 7202957,
    "stars": 10.53,
    "bpm": 193,
    "length": 408,
    "status": "ranked",
    "playcount": 8766,
    "favouriteCount": 159,
    "rankedDate": "2025-07-05T00:05:04Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2302059/covers/cover.jpg?1751574940",
      "card": "https://assets.ppy.sh/beatmaps/2302059/covers/card.jpg?1751574940",
      "list": "https://assets.ppy.sh/beatmaps/2302059/covers/list.jpg?1751574940",
      "slimcover": "https://assets.ppy.sh/beatmaps/2302059/covers/slimcover.jpg?1751574940"
    },
    "previewUrl": "https://b.ppy.sh/preview/2302059.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.98,
    "mode": 0
  },
  {
    "id": 577959,
    "beatmapsetId": 251663,
    "artist": "Luck Ganriki",
    "artistUnicode": "ラック眼力",
    "title": "Furuki Ashiki",
    "titleUnicode": "フルキアシキ",
    "version": "Pandora's Box",
    "creator": "Okoratu",
    "creatorId": 1623405,
    "stars": 3.5,
    "bpm": 86,
    "length": 135,
    "status": "ranked",
    "playcount": 303127,
    "favouriteCount": 178,
    "rankedDate": "2015-05-24T23:00:14Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/251663/covers/cover.jpg?1650626783",
      "card": "https://assets.ppy.sh/beatmaps/251663/covers/card.jpg?1650626783",
      "list": "https://assets.ppy.sh/beatmaps/251663/covers/list.jpg?1650626783",
      "slimcover": "https://assets.ppy.sh/beatmaps/251663/covers/slimcover.jpg?1650626783"
    },
    "previewUrl": "https://b.ppy.sh/preview/251663.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.97,
    "mode": 0
  },
  {
    "id": 766190,
    "beatmapsetId": 345834,
    "artist": "sasakure.UK",
    "title": "AVALONnayo,AVALONna...!!.mp4",
    "version": "Normal",
    "creator": "Furan_495",
    "stars": 24.94,
    "bpm": 200,
    "length": 137,
    "status": "loved",
    "playcount": 188220,
    "favouriteCount": 229,
    "rankedDate": "2016-11-14T04:23:54Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/345834/covers/cover.jpg?1622091692",
      "card": "https://assets.ppy.sh/beatmaps/345834/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/345834/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/345834/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/345834.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.97,
    "mode": 0
  },
  {
    "id": 4449788,
    "beatmapsetId": 2063381,
    "artist": "REDALiCE & aran",
    "artistUnicode": "REDALiCE & aran",
    "title": "Sweet Requiem",
    "titleUnicode": "Sweet Requiem",
    "version": "Flying Maiden",
    "creator": "Noob_Oni",
    "creatorId": 33455007,
    "stars": 6.29,
    "bpm": 190,
    "length": 117,
    "status": "ranked",
    "playcount": 126834,
    "favouriteCount": 204,
    "rankedDate": "2024-12-30T04:44:27Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2063381/covers/cover.jpg?1734846290",
      "card": "https://assets.ppy.sh/beatmaps/2063381/covers/card.jpg?1734846290",
      "list": "https://assets.ppy.sh/beatmaps/2063381/covers/list.jpg?1734846290",
      "slimcover": "https://assets.ppy.sh/beatmaps/2063381/covers/slimcover.jpg?1734846290"
    },
    "previewUrl": "https://b.ppy.sh/preview/2063381.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.97,
    "mode": 0
  },
  {
    "id": 4395015,
    "beatmapsetId": 2091742,
    "artist": "Coaltar Of The Deepers",
    "artistUnicode": "Coaltar Of The Deepers",
    "title": "dl++[delatetei] (Sadesper Record Mix)",
    "titleUnicode": "dl++[delatetei] (Sadesper Record Mix)",
    "version": "Harder",
    "creator": "Mirash",
    "creatorId": 2841009,
    "stars": 8.99,
    "bpm": 170,
    "length": 165,
    "status": "loved",
    "playcount": 49197,
    "favouriteCount": 194,
    "rankedDate": "2024-12-04T13:39:12Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2091742/covers/cover.jpg?1732966250",
      "card": "https://assets.ppy.sh/beatmaps/2091742/covers/card.jpg?1732966250",
      "list": "https://assets.ppy.sh/beatmaps/2091742/covers/list.jpg?1732966250",
      "slimcover": "https://assets.ppy.sh/beatmaps/2091742/covers/slimcover.jpg?1732966250"
    },
    "previewUrl": "https://b.ppy.sh/preview/2091742.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.97,
    "mode": 0
  },
  {
    "id": 1295746,
    "beatmapsetId": 614195,
    "artist": "Fujita Akane, Miyamoto Yume, Ozawa Ari",
    "artistUnicode": "藤田 茜、宮本侑芽、小澤亜李",
    "title": "Precious You*",
    "titleUnicode": "Precious You☆",
    "version": "Insane",
    "creator": "a q p w",
    "creatorId": 3056732,
    "stars": 3.83,
    "bpm": 130,
    "length": 88,
    "status": "ranked",
    "playcount": 353574,
    "favouriteCount": 157,
    "rankedDate": "2017-10-03T07:40:30Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/614195/covers/cover.jpg?1650650084",
      "card": "https://assets.ppy.sh/beatmaps/614195/covers/card.jpg?1650650084",
      "list": "https://assets.ppy.sh/beatmaps/614195/covers/list.jpg?1650650084",
      "slimcover": "https://assets.ppy.sh/beatmaps/614195/covers/slimcover.jpg?1650650084"
    },
    "previewUrl": "https://b.ppy.sh/preview/614195.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 1941768,
    "beatmapsetId": 872038,
    "artist": "Pastel*Palettes",
    "artistUnicode": "Pastel＊Palettes",
    "title": "Zettai Sengen ~Recital~",
    "titleUnicode": "ゼッタイ宣言〜Recital〜",
    "version": "Spooky",
    "creator": "Doormat",
    "creatorId": 3230571,
    "stars": 5.83,
    "bpm": 177,
    "length": 104,
    "status": "ranked",
    "playcount": 287082,
    "favouriteCount": 185,
    "rankedDate": "2019-10-31T22:44:02Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/872038/covers/cover.jpg?1622149906",
      "card": "https://assets.ppy.sh/beatmaps/872038/covers/card.jpg?1622149906",
      "list": "https://assets.ppy.sh/beatmaps/872038/covers/list.jpg?1622149906",
      "slimcover": "https://assets.ppy.sh/beatmaps/872038/covers/slimcover.jpg?1622149906"
    },
    "previewUrl": "https://b.ppy.sh/preview/872038.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 2109845,
    "beatmapsetId": 1008086,
    "artist": "Pentakill",
    "artistUnicode": "Pentakill",
    "title": "Blade of the Ruined King",
    "titleUnicode": "Blade of the Ruined King",
    "version": "From the Depths of Shadow Isles",
    "creator": "SaltyLucario",
    "creatorId": 6571670,
    "stars": 7.19,
    "bpm": 151,
    "length": 412,
    "status": "ranked",
    "playcount": 61002,
    "favouriteCount": 187,
    "rankedDate": "2020-03-02T17:44:50Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1008086/covers/cover.jpg?1622166482",
      "card": "https://assets.ppy.sh/beatmaps/1008086/covers/card.jpg?1622166482",
      "list": "https://assets.ppy.sh/beatmaps/1008086/covers/list.jpg?1622166482",
      "slimcover": "https://assets.ppy.sh/beatmaps/1008086/covers/slimcover.jpg?1622166482"
    },
    "previewUrl": "https://b.ppy.sh/preview/1008086.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 4130112,
    "beatmapsetId": 1988187,
    "artist": "Pierce The Veil",
    "artistUnicode": "Pierce The Veil",
    "title": "Hold On Till May (feat. Lindsey Stamey)",
    "titleUnicode": "Hold On Till May (feat. Lindsey Stamey)",
    "version": "Another",
    "creator": "Ruiz Duchamp",
    "creatorId": 12416885,
    "stars": 5,
    "bpm": 146,
    "length": 236,
    "status": "ranked",
    "playcount": 59638,
    "favouriteCount": 195,
    "rankedDate": "2023-07-28T10:46:08Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1988187/covers/cover.jpg?1689908227",
      "card": "https://assets.ppy.sh/beatmaps/1988187/covers/card.jpg?1689908227",
      "list": "https://assets.ppy.sh/beatmaps/1988187/covers/list.jpg?1689908227",
      "slimcover": "https://assets.ppy.sh/beatmaps/1988187/covers/slimcover.jpg?1689908227"
    },
    "previewUrl": "https://b.ppy.sh/preview/1988187.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 5238714,
    "beatmapsetId": 2412294,
    "artist": "Krimek",
    "artistUnicode": "Krimek",
    "title": "Dahlia (feat. eili)",
    "titleUnicode": "Dahlia (feat. eili)",
    "version": "Expert",
    "creator": "Krimek",
    "creatorId": 2345078,
    "stars": 6.24,
    "bpm": 160,
    "length": 125,
    "status": "ranked",
    "playcount": 34729,
    "favouriteCount": 185,
    "rankedDate": "2026-07-16T23:42:30Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2412294/covers/cover.jpg?1783435077",
      "card": "https://assets.ppy.sh/beatmaps/2412294/covers/card.jpg?1783435077",
      "list": "https://assets.ppy.sh/beatmaps/2412294/covers/list.jpg?1783435077",
      "slimcover": "https://assets.ppy.sh/beatmaps/2412294/covers/slimcover.jpg?1783435077"
    },
    "previewUrl": "https://b.ppy.sh/preview/2412294.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 5358249,
    "beatmapsetId": 2423043,
    "artist": "Hayakore Tatsumi",
    "artistUnicode": "Hayakore Tatsumi",
    "title": "Thousandth Sky (END of SUMMER Mix)",
    "titleUnicode": "Thousandth Sky (END of SUMMER Mix)",
    "version": "Everlasting Summer",
    "creator": "saido39",
    "creatorId": 11278761,
    "stars": 7.15,
    "bpm": 190,
    "length": 395,
    "status": "ranked",
    "playcount": 33348,
    "favouriteCount": 175,
    "rankedDate": "2026-01-02T18:25:00Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2423043/covers/cover.jpg?1766443272",
      "card": "https://assets.ppy.sh/beatmaps/2423043/covers/card.jpg?1766443272",
      "list": "https://assets.ppy.sh/beatmaps/2423043/covers/list.jpg?1766443272",
      "slimcover": "https://assets.ppy.sh/beatmaps/2423043/covers/slimcover.jpg?1766443272"
    },
    "previewUrl": "https://b.ppy.sh/preview/2423043.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 5523311,
    "beatmapsetId": 2500998,
    "artist": "Aqu3ra / Runami Yachiyo (CV: Hayami Saori)",
    "artistUnicode": "Aqu3ra / 月見ヤチヨ (CV: 早見沙織)",
    "title": "Hoshi Furu Umi",
    "titleUnicode": "星降る海",
    "version": "Aquarium",
    "creator": "gust",
    "creatorId": 1244312,
    "stars": 5.71,
    "bpm": 101,
    "length": 247,
    "status": "ranked",
    "playcount": 21586,
    "favouriteCount": 180,
    "rankedDate": "2026-07-04T14:25:54Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2500998/covers/cover.jpg?1782548574",
      "card": "https://assets.ppy.sh/beatmaps/2500998/covers/card.jpg?1782548574",
      "list": "https://assets.ppy.sh/beatmaps/2500998/covers/list.jpg?1782548574",
      "slimcover": "https://assets.ppy.sh/beatmaps/2500998/covers/slimcover.jpg?1782548574"
    },
    "previewUrl": "https://b.ppy.sh/preview/2500998.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 1960574,
    "beatmapsetId": 937699,
    "artist": "Camellia",
    "artistUnicode": "かめりあ",
    "title": "Beyond the Geostationary Orbit Level",
    "titleUnicode": "Beyond the Geostationary Orbit Level",
    "version": "Synesthesia",
    "creator": "EijiKuinbii",
    "creatorId": 6270995,
    "stars": 8.28,
    "bpm": 175,
    "length": 290,
    "status": "loved",
    "playcount": 17137,
    "favouriteCount": 182,
    "rankedDate": "2025-04-06T03:29:40Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/937699/covers/cover.jpg?1769508974",
      "card": "https://assets.ppy.sh/beatmaps/937699/covers/card.jpg?1769508974",
      "list": "https://assets.ppy.sh/beatmaps/937699/covers/list.jpg?1769508974",
      "slimcover": "https://assets.ppy.sh/beatmaps/937699/covers/slimcover.jpg?1769508974"
    },
    "previewUrl": "https://b.ppy.sh/preview/937699.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.96,
    "mode": 0
  },
  {
    "id": 1966553,
    "beatmapsetId": 941757,
    "artist": "Pecorine (CV: M.A.O), Kokkoro (CV: Itou Miku), Karyl (CV: Tachibana Rika)",
    "artistUnicode": "ペコリーヌ（CV：M・A・O）、コッコロ（CV：伊藤美来）、キャル（CV：立花理香）",
    "title": "Connecting Happy!!",
    "titleUnicode": "Connecting Happy!!",
    "version": "Innocent Connection",
    "creator": "MiyohashiKoori",
    "creatorId": 5050004,
    "stars": 6.18,
    "bpm": 182,
    "length": 273,
    "status": "ranked",
    "playcount": 316665,
    "favouriteCount": 170,
    "rankedDate": "2019-08-15T11:40:02Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/941757/covers/cover.jpg?1650683292",
      "card": "https://assets.ppy.sh/beatmaps/941757/covers/card.jpg?1650683292",
      "list": "https://assets.ppy.sh/beatmaps/941757/covers/list.jpg?1650683292",
      "slimcover": "https://assets.ppy.sh/beatmaps/941757/covers/slimcover.jpg?1650683292"
    },
    "previewUrl": "https://b.ppy.sh/preview/941757.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.95,
    "mode": 0
  },
  {
    "id": 2397750,
    "beatmapsetId": 1148452,
    "artist": "Sonar Pocket",
    "artistUnicode": "ソナーポケット",
    "title": "GIRIGIRI (TV Size)",
    "titleUnicode": "GIRIGIRI (TV Size)",
    "version": "BRINK",
    "creator": "Yudragen",
    "creatorId": 8406396,
    "stars": 5.71,
    "bpm": 140,
    "length": 87,
    "status": "ranked",
    "playcount": 215428,
    "favouriteCount": 182,
    "rankedDate": "2020-09-15T18:23:30Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1148452/covers/cover.jpg?1622186614",
      "card": "https://assets.ppy.sh/beatmaps/1148452/covers/card.jpg?1622186614",
      "list": "https://assets.ppy.sh/beatmaps/1148452/covers/list.jpg?1622186614",
      "slimcover": "https://assets.ppy.sh/beatmaps/1148452/covers/slimcover.jpg?1622186614"
    },
    "previewUrl": "https://b.ppy.sh/preview/1148452.mp3",
    "rarity": "Uncommon",
    "popularityScore": 55.95,
    "mode": 0
  },
  {
    "id": 517651,
    "beatmapsetId": 221250,
    "artist": "Kurosaki Maon",
    "title": "Rakuen no Tsubasa",
    "version": "Insane",
    "creator": "Tari",
    "stars": 4.2,
    "bpm": 155,
    "length": 88,
    "status": "ranked",
    "playcount": 752576,
    "favouriteCount": 297,
    "rankedDate": "2014-11-21T01:20:40Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/221250/covers/cover.jpg?1650625171",
      "card": "https://assets.ppy.sh/beatmaps/221250/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/221250/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/221250/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/221250.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 28598,
    "beatmapsetId": 6189,
    "artist": "Tamaki Nami",
    "title": "Realize",
    "version": "Genesis",
    "creator": "deepsea",
    "stars": 4.87,
    "bpm": 136.15,
    "length": 187,
    "status": "ranked",
    "playcount": 523663,
    "favouriteCount": 313,
    "rankedDate": "2009-08-06T16:48:32Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/6189/covers/cover.jpg?1650602201",
      "card": "https://assets.ppy.sh/beatmaps/6189/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/6189/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/6189/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/6189.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 380029,
    "beatmapsetId": 154833,
    "artist": "Kuroneko Dungeon",
    "artistUnicode": "黒猫ダンジョン",
    "title": "Ryuu to Shoujo to Decoherence",
    "titleUnicode": "龍と少女とデコヒーレンス",
    "version": "Overdrive",
    "creator": "Flower",
    "creatorId": 1033017,
    "stars": 7.1,
    "bpm": 165,
    "length": 117,
    "status": "loved",
    "playcount": 415098,
    "favouriteCount": 441,
    "rankedDate": "2018-05-27T23:18:29Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/154833/covers/cover.jpg?1622072018",
      "card": "https://assets.ppy.sh/beatmaps/154833/covers/card.jpg?1622072018",
      "list": "https://assets.ppy.sh/beatmaps/154833/covers/list.jpg?1622072018",
      "slimcover": "https://assets.ppy.sh/beatmaps/154833/covers/slimcover.jpg?1622072018"
    },
    "previewUrl": "https://b.ppy.sh/preview/154833.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 3754168,
    "beatmapsetId": 1829152,
    "artist": "Massive New Krew",
    "artistUnicode": "Massive New Krew",
    "title": "Bullshit",
    "titleUnicode": "Bullshit",
    "version": "************",
    "creator": "Icekalt",
    "creatorId": 5410645,
    "stars": 7.36,
    "bpm": 160,
    "length": 213,
    "status": "ranked",
    "playcount": 205566,
    "favouriteCount": 420,
    "rankedDate": "2022-11-21T21:45:49Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1829152/covers/cover.jpg?1668103879",
      "card": "https://assets.ppy.sh/beatmaps/1829152/covers/card.jpg?1668103879",
      "list": "https://assets.ppy.sh/beatmaps/1829152/covers/list.jpg?1668103879",
      "slimcover": "https://assets.ppy.sh/beatmaps/1829152/covers/slimcover.jpg?1668103879"
    },
    "previewUrl": "https://b.ppy.sh/preview/1829152.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 4749407,
    "beatmapsetId": 2235787,
    "artist": "Camellia",
    "artistUnicode": "かめりあ",
    "title": "crystallized",
    "titleUnicode": "crystallized",
    "version": "Deluxe",
    "creator": "Chaoslitz",
    "creatorId": 3621552,
    "stars": 6.27,
    "bpm": 174,
    "length": 260,
    "status": "ranked",
    "playcount": 185660,
    "favouriteCount": 425,
    "rankedDate": "2024-09-24T14:22:44Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2235787/covers/cover.jpg?1726574596",
      "card": "https://assets.ppy.sh/beatmaps/2235787/covers/card.jpg?1726574596",
      "list": "https://assets.ppy.sh/beatmaps/2235787/covers/list.jpg?1726574596",
      "slimcover": "https://assets.ppy.sh/beatmaps/2235787/covers/slimcover.jpg?1726574596"
    },
    "previewUrl": "https://b.ppy.sh/preview/2235787.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 2962115,
    "beatmapsetId": 1439651,
    "artist": "Certified Senpai",
    "artistUnicode": "Certified Senpai",
    "title": "Burn This Right",
    "titleUnicode": "Burn This Right",
    "version": "Relentless",
    "creator": "Hectic",
    "creatorId": 6885942,
    "stars": 8.12,
    "bpm": 204,
    "length": 330,
    "status": "ranked",
    "playcount": 123472,
    "favouriteCount": 421,
    "rankedDate": "2021-08-24T23:23:15Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1439651/covers/cover.jpg?1629182484",
      "card": "https://assets.ppy.sh/beatmaps/1439651/covers/card.jpg?1629182484",
      "list": "https://assets.ppy.sh/beatmaps/1439651/covers/list.jpg?1629182484",
      "slimcover": "https://assets.ppy.sh/beatmaps/1439651/covers/slimcover.jpg?1629182484"
    },
    "previewUrl": "https://b.ppy.sh/preview/1439651.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 5322633,
    "beatmapsetId": 2440153,
    "artist": "F-777",
    "artistUnicode": "F-777",
    "title": "Deadlocked",
    "titleUnicode": "Deadlocked",
    "version": "Zugzwang",
    "creator": "Visionary",
    "creatorId": 7704651,
    "stars": 7.12,
    "bpm": 135,
    "length": 114,
    "status": "ranked",
    "playcount": 116078,
    "favouriteCount": 441,
    "rankedDate": "2025-11-20T14:42:31Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2440153/covers/cover.jpg?1762963172",
      "card": "https://assets.ppy.sh/beatmaps/2440153/covers/card.jpg?1762963172",
      "list": "https://assets.ppy.sh/beatmaps/2440153/covers/list.jpg?1762963172",
      "slimcover": "https://assets.ppy.sh/beatmaps/2440153/covers/slimcover.jpg?1762963172"
    },
    "previewUrl": "https://b.ppy.sh/preview/2440153.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.88,
    "mode": 0
  },
  {
    "id": 1556011,
    "beatmapsetId": 737340,
    "artist": "Gesu no Kiwami Otome.",
    "artistUnicode": "ゲスの極み乙女。",
    "title": "Digital Mogura",
    "titleUnicode": "デジタルモグラ",
    "version": "Idealist",
    "creator": "dsco",
    "creatorId": 4330511,
    "stars": 6.9,
    "bpm": 140,
    "length": 213,
    "status": "ranked",
    "playcount": 167593,
    "favouriteCount": 431,
    "rankedDate": "2021-08-31T05:46:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/737340/covers/cover.jpg?1629754075",
      "card": "https://assets.ppy.sh/beatmaps/737340/covers/card.jpg?1629754075",
      "list": "https://assets.ppy.sh/beatmaps/737340/covers/list.jpg?1629754075",
      "slimcover": "https://assets.ppy.sh/beatmaps/737340/covers/slimcover.jpg?1629754075"
    },
    "previewUrl": "https://b.ppy.sh/preview/737340.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.87,
    "mode": 0
  },
  {
    "id": 966307,
    "beatmapsetId": 450393,
    "artist": "ClariS",
    "artistUnicode": "ClariS",
    "title": "Wake Up -TV MIX-",
    "titleUnicode": "Wake Up -TV MIX-",
    "version": "Insane",
    "creator": "Doyak",
    "creatorId": 2046893,
    "stars": 3.93,
    "bpm": 132,
    "length": 88,
    "status": "ranked",
    "playcount": 2163523,
    "favouriteCount": 173,
    "rankedDate": "2016-06-25T18:20:14Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/450393/covers/cover.jpg?1650638945",
      "card": "https://assets.ppy.sh/beatmaps/450393/covers/card.jpg?1650638945",
      "list": "https://assets.ppy.sh/beatmaps/450393/covers/list.jpg?1650638945",
      "slimcover": "https://assets.ppy.sh/beatmaps/450393/covers/slimcover.jpg?1650638945"
    },
    "previewUrl": "https://b.ppy.sh/preview/450393.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.86,
    "mode": 0
  },
  {
    "id": 2485667,
    "beatmapsetId": 1192891,
    "artist": "serial TV drama",
    "artistUnicode": "serial TV drama",
    "title": "Tougenkyou Alien (TV Size)",
    "titleUnicode": "桃源郷エイリアン (TV Size)",
    "version": "Expert",
    "creator": "Smoke",
    "creatorId": 10726630,
    "stars": 5.63,
    "bpm": 170,
    "length": 90,
    "status": "ranked",
    "playcount": 503406,
    "favouriteCount": 313,
    "rankedDate": "2020-07-21T19:06:31Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1192891/covers/cover.jpg?1650697162",
      "card": "https://assets.ppy.sh/beatmaps/1192891/covers/card.jpg?1650697162",
      "list": "https://assets.ppy.sh/beatmaps/1192891/covers/list.jpg?1650697162",
      "slimcover": "https://assets.ppy.sh/beatmaps/1192891/covers/slimcover.jpg?1650697162"
    },
    "previewUrl": "https://b.ppy.sh/preview/1192891.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.86,
    "mode": 0
  },
  {
    "id": 3083774,
    "beatmapsetId": 1070184,
    "artist": "Rocket Sister",
    "artistUnicode": "Rocket Sister",
    "title": "Blackout (Cut Ver.)",
    "titleUnicode": "Blackout (Cut Ver.)",
    "version": "Nightmare",
    "creator": "Maiev",
    "creatorId": 10183830,
    "stars": 6.3,
    "bpm": 200,
    "length": 94,
    "status": "ranked",
    "playcount": 442329,
    "favouriteCount": 333,
    "rankedDate": "2021-09-05T15:40:56Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1070184/covers/cover.jpg?1630250589",
      "card": "https://assets.ppy.sh/beatmaps/1070184/covers/card.jpg?1630250589",
      "list": "https://assets.ppy.sh/beatmaps/1070184/covers/list.jpg?1630250589",
      "slimcover": "https://assets.ppy.sh/beatmaps/1070184/covers/slimcover.jpg?1630250589"
    },
    "previewUrl": "https://b.ppy.sh/preview/1070184.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.86,
    "mode": 0
  },
  {
    "id": 1610046,
    "beatmapsetId": 765801,
    "artist": "Armin van Buuren vs. Vini Vici feat. Hilight Tribe",
    "artistUnicode": "Armin van Buuren vs. Vini Vici feat. Hilight Tribe",
    "title": "Great Spirit (Extended Mix)",
    "titleUnicode": "Great Spirit (Extended Mix)",
    "version": "Tribal Echoes",
    "creator": "IceKalt",
    "creatorId": 5410645,
    "stars": 6.87,
    "bpm": 138,
    "length": 449,
    "status": "ranked",
    "playcount": 299430,
    "favouriteCount": 428,
    "rankedDate": "2018-10-07T19:00:19Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/765801/covers/cover.jpg?1622138097",
      "card": "https://assets.ppy.sh/beatmaps/765801/covers/card.jpg?1622138097",
      "list": "https://assets.ppy.sh/beatmaps/765801/covers/list.jpg?1622138097",
      "slimcover": "https://assets.ppy.sh/beatmaps/765801/covers/slimcover.jpg?1622138097"
    },
    "previewUrl": "https://b.ppy.sh/preview/765801.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.86,
    "mode": 0
  },
  {
    "id": 3722665,
    "beatmapsetId": 1814686,
    "artist": "my sound life",
    "artistUnicode": "my sound life",
    "title": "AIR",
    "titleUnicode": "AIR",
    "version": "Collab Extra",
    "creator": "Mirash",
    "creatorId": 2841009,
    "stars": 6.37,
    "bpm": 180,
    "length": 301,
    "status": "ranked",
    "playcount": 89021,
    "favouriteCount": 444,
    "rankedDate": "2022-08-08T10:05:02Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1814686/covers/cover.jpg?1659265969",
      "card": "https://assets.ppy.sh/beatmaps/1814686/covers/card.jpg?1659265969",
      "list": "https://assets.ppy.sh/beatmaps/1814686/covers/list.jpg?1659265969",
      "slimcover": "https://assets.ppy.sh/beatmaps/1814686/covers/slimcover.jpg?1659265969"
    },
    "previewUrl": "https://b.ppy.sh/preview/1814686.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.86,
    "mode": 0
  },
  {
    "id": 102270,
    "beatmapsetId": 31061,
    "artist": "Hashimoto Miyuki",
    "artistUnicode": "Hashimoto Miyuki",
    "title": "Yume miru mama ni Koi wo shite",
    "titleUnicode": "Yume miru mama ni Koi wo shite",
    "version": "Insane",
    "creator": "S i R i R u",
    "creatorId": 108066,
    "stars": 4.53,
    "bpm": 160,
    "length": 96,
    "status": "ranked",
    "playcount": 949552,
    "favouriteCount": 215,
    "rankedDate": "2011-06-30T19:39:16Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/31061/covers/cover.jpg?1622047468",
      "card": "https://assets.ppy.sh/beatmaps/31061/covers/card.jpg?1622047468",
      "list": "https://assets.ppy.sh/beatmaps/31061/covers/list.jpg?1622047468",
      "slimcover": "https://assets.ppy.sh/beatmaps/31061/covers/slimcover.jpg?1622047468"
    },
    "previewUrl": "https://b.ppy.sh/preview/31061.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 101916,
    "beatmapsetId": 30939,
    "artist": "Hatsune Miku",
    "artistUnicode": "Hatsune Miku",
    "title": "BadBye",
    "titleUnicode": "BadBye",
    "version": "GoodBye",
    "creator": "goodbye",
    "creatorId": 102976,
    "stars": 4.5,
    "bpm": 140,
    "length": 175,
    "status": "ranked",
    "playcount": 662351,
    "favouriteCount": 269,
    "rankedDate": "2011-09-24T09:49:53Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/30939/covers/cover.jpg?1622047405",
      "card": "https://assets.ppy.sh/beatmaps/30939/covers/card.jpg?1622047405",
      "list": "https://assets.ppy.sh/beatmaps/30939/covers/list.jpg?1622047405",
      "slimcover": "https://assets.ppy.sh/beatmaps/30939/covers/slimcover.jpg?1622047405"
    },
    "previewUrl": "https://b.ppy.sh/preview/30939.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 167963,
    "beatmapsetId": 55359,
    "artist": "Hatsuki Yura",
    "title": "Ganbare! Koi no Hana",
    "version": "Hana",
    "creator": "Kotone",
    "stars": 4.05,
    "bpm": 140,
    "length": 159,
    "status": "ranked",
    "playcount": 577363,
    "favouriteCount": 347,
    "rankedDate": "2012-11-22T23:32:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/55359/covers/cover.jpg?1650614142",
      "card": "https://assets.ppy.sh/beatmaps/55359/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/55359/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/55359/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/55359.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 1508554,
    "beatmapsetId": 713756,
    "artist": "JUNNA",
    "artistUnicode": "JUNNA",
    "title": "Here",
    "titleUnicode": "Here",
    "version": "Sandwich Silky",
    "creator": "Hakura",
    "creatorId": 3789276,
    "stars": 5.31,
    "bpm": 108,
    "length": 88,
    "status": "ranked",
    "playcount": 562239,
    "favouriteCount": 357,
    "rankedDate": "2018-01-18T21:40:21Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/713756/covers/cover.jpg?1622130798",
      "card": "https://assets.ppy.sh/beatmaps/713756/covers/card.jpg?1622130798",
      "list": "https://assets.ppy.sh/beatmaps/713756/covers/list.jpg?1622130798",
      "slimcover": "https://assets.ppy.sh/beatmaps/713756/covers/slimcover.jpg?1622130798"
    },
    "previewUrl": "https://b.ppy.sh/preview/713756.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 1803069,
    "beatmapsetId": 861946,
    "artist": "Shikata Akiko",
    "artistUnicode": "志方あきこ",
    "title": "Tsukiyo no Ongakukai",
    "titleUnicode": "月夜の音楽会",
    "version": "Kimi no Uta",
    "creator": "Hey lululu",
    "creatorId": 4086497,
    "stars": 6.39,
    "bpm": 220,
    "length": 107,
    "status": "ranked",
    "playcount": 551187,
    "favouriteCount": 361,
    "rankedDate": "2019-01-09T13:40:20Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/861946/covers/cover.jpg?1650671343",
      "card": "https://assets.ppy.sh/beatmaps/861946/covers/card.jpg?1650671343",
      "list": "https://assets.ppy.sh/beatmaps/861946/covers/list.jpg?1650671343",
      "slimcover": "https://assets.ppy.sh/beatmaps/861946/covers/slimcover.jpg?1650671343"
    },
    "previewUrl": "https://b.ppy.sh/preview/861946.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 1345714,
    "beatmapsetId": 614131,
    "artist": "bo en",
    "title": "my time (OMORI Ver.)",
    "version": "Kondou's Dream",
    "creator": "JeirYagtama",
    "stars": 7.78,
    "bpm": 199.07,
    "length": 206,
    "status": "graveyard",
    "playcount": 496183,
    "favouriteCount": 494,
    "rankedDate": "2017-05-16T13:35:30Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/614131/covers/cover.jpg?1772628800",
      "card": "https://assets.ppy.sh/beatmaps/614131/covers/card.jpg",
      "list": "https://assets.ppy.sh/beatmaps/614131/covers/list.jpg",
      "slimcover": "https://assets.ppy.sh/beatmaps/614131/covers/slimcover.jpg"
    },
    "previewUrl": "https://b.ppy.sh/preview/614131.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 4447349,
    "beatmapsetId": 2117629,
    "artist": "Takahashi Azumi feat. Lotus Juice",
    "artistUnicode": "高橋あず美 feat. Lotus Juice",
    "title": "Full Moon Full Life -Opening Movie version-",
    "titleUnicode": "Full Moon Full Life -Opening Movie version-",
    "version": "The Answer",
    "creator": "Yogurtt",
    "creatorId": 2649717,
    "stars": 5.46,
    "bpm": 193,
    "length": 90,
    "status": "ranked",
    "playcount": 264119,
    "favouriteCount": 404,
    "rankedDate": "2024-02-04T21:01:20Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2117629/covers/cover.jpg?1706829592",
      "card": "https://assets.ppy.sh/beatmaps/2117629/covers/card.jpg?1706829592",
      "list": "https://assets.ppy.sh/beatmaps/2117629/covers/list.jpg?1706829592",
      "slimcover": "https://assets.ppy.sh/beatmaps/2117629/covers/slimcover.jpg?1706829592"
    },
    "previewUrl": "https://b.ppy.sh/preview/2117629.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 216502,
    "beatmapsetId": 69354,
    "artist": "Jimmy Thumb P",
    "artistUnicode": "ジミーサムP",
    "title": "Reboot",
    "titleUnicode": "Reboot",
    "version": "Reboot",
    "creator": "L_P",
    "creatorId": 982308,
    "stars": 3.91,
    "bpm": 152,
    "length": 259,
    "status": "ranked",
    "playcount": 262672,
    "favouriteCount": 471,
    "rankedDate": "2013-06-14T11:00:09Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/69354/covers/cover.jpg?1650615186",
      "card": "https://assets.ppy.sh/beatmaps/69354/covers/card.jpg?1650615186",
      "list": "https://assets.ppy.sh/beatmaps/69354/covers/list.jpg?1650615186",
      "slimcover": "https://assets.ppy.sh/beatmaps/69354/covers/slimcover.jpg?1650615186"
    },
    "previewUrl": "https://b.ppy.sh/preview/69354.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.85,
    "mode": 0
  },
  {
    "id": 3983117,
    "beatmapsetId": 1928730,
    "artist": "Oishi Masayoshi",
    "artistUnicode": "オーイシマサヨシ",
    "title": "Gift (TV Size)",
    "titleUnicode": "ギフト (TV Size)",
    "version": "My Angel Mahiru <3",
    "creator": "Sekai",
    "creatorId": 700887,
    "stars": 5.18,
    "bpm": 264,
    "length": 86,
    "status": "ranked",
    "playcount": 311170,
    "favouriteCount": 385,
    "rankedDate": "2023-02-16T06:05:14Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1928730/covers/cover.jpg?1675916976",
      "card": "https://assets.ppy.sh/beatmaps/1928730/covers/card.jpg?1675916976",
      "list": "https://assets.ppy.sh/beatmaps/1928730/covers/list.jpg?1675916976",
      "slimcover": "https://assets.ppy.sh/beatmaps/1928730/covers/slimcover.jpg?1675916976"
    },
    "previewUrl": "https://b.ppy.sh/preview/1928730.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.84,
    "mode": 0
  },
  {
    "id": 1816315,
    "beatmapsetId": 869054,
    "artist": "Frederic Chopin",
    "artistUnicode": "Frédéric Chopin",
    "title": "Etude Op. 10, No. 5",
    "titleUnicode": "Étude Op. 10, No. 5",
    "version": "Vivace",
    "creator": "Riana",
    "creatorId": 1997633,
    "stars": 6.53,
    "bpm": 116,
    "length": 90,
    "status": "ranked",
    "playcount": 297203,
    "favouriteCount": 391,
    "rankedDate": "2021-12-23T20:04:18Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/869054/covers/cover.jpg?1640289875",
      "card": "https://assets.ppy.sh/beatmaps/869054/covers/card.jpg?1640289875",
      "list": "https://assets.ppy.sh/beatmaps/869054/covers/list.jpg?1640289875",
      "slimcover": "https://assets.ppy.sh/beatmaps/869054/covers/slimcover.jpg?1640289875"
    },
    "previewUrl": "https://b.ppy.sh/preview/869054.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.84,
    "mode": 0
  },
  {
    "id": 3444830,
    "beatmapsetId": 1685602,
    "artist": "RADWIMPS",
    "artistUnicode": "RADWIMPS",
    "title": "Sparkle [original ver.]",
    "titleUnicode": "スパークル [original ver.]",
    "version": "In this world with you",
    "creator": "Nuvolina",
    "creatorId": 10974170,
    "stars": 4.99,
    "bpm": 124,
    "length": 400,
    "status": "ranked",
    "playcount": 93655,
    "favouriteCount": 425,
    "rankedDate": "2022-02-22T10:46:27Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1685602/covers/cover.jpg?1645297218",
      "card": "https://assets.ppy.sh/beatmaps/1685602/covers/card.jpg?1645297218",
      "list": "https://assets.ppy.sh/beatmaps/1685602/covers/list.jpg?1645297218",
      "slimcover": "https://assets.ppy.sh/beatmaps/1685602/covers/slimcover.jpg?1645297218"
    },
    "previewUrl": "https://b.ppy.sh/preview/1685602.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.84,
    "mode": 0
  },
  {
    "id": 3896655,
    "beatmapsetId": 1891236,
    "artist": "bye2",
    "artistUnicode": "bye2",
    "title": "onionfriends2004",
    "titleUnicode": "onionfriends2004",
    "version": "deru?",
    "creator": "Cofffelo",
    "creatorId": 14509479,
    "stars": 7.48,
    "bpm": 190,
    "length": 308,
    "status": "ranked",
    "playcount": 66097,
    "favouriteCount": 449,
    "rankedDate": "2024-01-17T18:03:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1891236/covers/cover.jpg?1704908989",
      "card": "https://assets.ppy.sh/beatmaps/1891236/covers/card.jpg?1704908989",
      "list": "https://assets.ppy.sh/beatmaps/1891236/covers/list.jpg?1704908989",
      "slimcover": "https://assets.ppy.sh/beatmaps/1891236/covers/slimcover.jpg?1704908989"
    },
    "previewUrl": "https://b.ppy.sh/preview/1891236.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.84,
    "mode": 0
  },
  {
    "id": 1811676,
    "beatmapsetId": 866562,
    "artist": "OFFICIAL HIGE DANDISM",
    "artistUnicode": "OFFICIAL髭男DISM",
    "title": "FIRE GROUND (TV Size)",
    "titleUnicode": "FIRE GROUND (TV Size)",
    "version": "Heated Resistance",
    "creator": "Yudragen",
    "creatorId": 8406396,
    "stars": 5.97,
    "bpm": 114,
    "length": 90,
    "status": "ranked",
    "playcount": 699858,
    "favouriteCount": 313,
    "rankedDate": "2019-01-12T22:40:06Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/866562/covers/cover.jpg?1650671156",
      "card": "https://assets.ppy.sh/beatmaps/866562/covers/card.jpg?1650671156",
      "list": "https://assets.ppy.sh/beatmaps/866562/covers/list.jpg?1650671156",
      "slimcover": "https://assets.ppy.sh/beatmaps/866562/covers/slimcover.jpg?1650671156"
    },
    "previewUrl": "https://b.ppy.sh/preview/866562.mp3",
    "rarity": "Uncommon+",
    "popularityScore": 71.83,
    "mode": 0
  },
  {
    "id": 2604568,
    "beatmapsetId": 1253246,
    "artist": "positive MAD-crew",
    "artistUnicode": "positive MAD-crew",
    "title": "Mynarco",
    "titleUnicode": "Mynarco",
    "version": "Expert",
    "creator": "revoh",
    "creatorId": 8165181,
    "stars": 6.59,
    "bpm": 181,
    "length": 104,
    "status": "ranked",
    "playcount": 3147620,
    "favouriteCount": 507,
    "rankedDate": "2020-11-09T21:25:46Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1253246/covers/cover.jpg?1645779972",
      "card": "https://assets.ppy.sh/beatmaps/1253246/covers/card.jpg?1645779972",
      "list": "https://assets.ppy.sh/beatmaps/1253246/covers/list.jpg?1645779972",
      "slimcover": "https://assets.ppy.sh/beatmaps/1253246/covers/slimcover.jpg?1645779972"
    },
    "previewUrl": "https://b.ppy.sh/preview/1253246.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 129613,
    "beatmapsetId": 37235,
    "artist": "Melanie Flash",
    "artistUnicode": "Melanie Flash",
    "title": "One in a Million (Nightcore Mix)",
    "titleUnicode": "One in a Million (Nightcore Mix)",
    "version": "jericho2442's Rave!!",
    "creator": "Makar8000",
    "creatorId": 686389,
    "stars": 4.41,
    "bpm": 174,
    "length": 147,
    "status": "ranked",
    "playcount": 1831655,
    "favouriteCount": 695,
    "rankedDate": "2012-01-10T17:51:23Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/37235/covers/cover.jpg?1650609852",
      "card": "https://assets.ppy.sh/beatmaps/37235/covers/card.jpg?1650609852",
      "list": "https://assets.ppy.sh/beatmaps/37235/covers/list.jpg?1650609852",
      "slimcover": "https://assets.ppy.sh/beatmaps/37235/covers/slimcover.jpg?1650609852"
    },
    "previewUrl": "https://b.ppy.sh/preview/37235.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 2221095,
    "beatmapsetId": 1060866,
    "artist": "Krewella",
    "artistUnicode": "Krewella",
    "title": "Ghost",
    "titleUnicode": "Ghost",
    "version": "Collab Untouchable",
    "creator": "Altai",
    "creatorId": 5745865,
    "stars": 6.29,
    "bpm": 190,
    "length": 179,
    "status": "ranked",
    "playcount": 1170738,
    "favouriteCount": 721,
    "rankedDate": "2020-05-09T20:42:42Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1060866/covers/cover.jpg?1650693961",
      "card": "https://assets.ppy.sh/beatmaps/1060866/covers/card.jpg?1650693961",
      "list": "https://assets.ppy.sh/beatmaps/1060866/covers/list.jpg?1650693961",
      "slimcover": "https://assets.ppy.sh/beatmaps/1060866/covers/slimcover.jpg?1650693961"
    },
    "previewUrl": "https://b.ppy.sh/preview/1060866.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 29426,
    "beatmapsetId": 6432,
    "artist": "Rin Kagamine & Len Kagamine",
    "artistUnicode": "Rin Kagamine & Len Kagamine",
    "title": "Cantarella",
    "titleUnicode": "Cantarella",
    "version": "Hard",
    "creator": "xxheroxx",
    "creatorId": 25999,
    "stars": 3.71,
    "bpm": 144,
    "length": 158,
    "status": "ranked",
    "playcount": 788562,
    "favouriteCount": 893,
    "rankedDate": "2009-09-03T20:44:41Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/6432/covers/cover.jpg?1622024255",
      "card": "https://assets.ppy.sh/beatmaps/6432/covers/card.jpg?1622024255",
      "list": "https://assets.ppy.sh/beatmaps/6432/covers/list.jpg?1622024255",
      "slimcover": "https://assets.ppy.sh/beatmaps/6432/covers/slimcover.jpg?1622024255"
    },
    "previewUrl": "https://b.ppy.sh/preview/6432.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 2446847,
    "beatmapsetId": 1165550,
    "artist": "Flex",
    "artistUnicode": "Flex",
    "title": "Ferris' Sand Canyon",
    "titleUnicode": "Ferris' Sand Canyon",
    "version": "DJPop's Extreme",
    "creator": "Net0",
    "creatorId": 5099768,
    "stars": 7.18,
    "bpm": 159,
    "length": 73,
    "status": "ranked",
    "playcount": 754289,
    "favouriteCount": 866,
    "rankedDate": "2021-09-24T20:42:53Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1165550/covers/cover.jpg?1650695261",
      "card": "https://assets.ppy.sh/beatmaps/1165550/covers/card.jpg?1650695261",
      "list": "https://assets.ppy.sh/beatmaps/1165550/covers/list.jpg?1650695261",
      "slimcover": "https://assets.ppy.sh/beatmaps/1165550/covers/slimcover.jpg?1650695261"
    },
    "previewUrl": "https://b.ppy.sh/preview/1165550.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 4495561,
    "beatmapsetId": 2136372,
    "artist": "HOYO-MiX",
    "artistUnicode": "HOYO-MiX",
    "title": "If I Can Stop One Heart From Breaking",
    "titleUnicode": "If I Can Stop One Heart From Breaking",
    "version": "Longing Dream",
    "creator": "Andrea",
    "creatorId": 33599,
    "stars": 4.26,
    "bpm": 160,
    "length": 193,
    "status": "ranked",
    "playcount": 313798,
    "favouriteCount": 1257,
    "rankedDate": "2024-02-26T21:23:35Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/2136372/covers/cover.jpg?1708312987",
      "card": "https://assets.ppy.sh/beatmaps/2136372/covers/card.jpg?1708312987",
      "list": "https://assets.ppy.sh/beatmaps/2136372/covers/list.jpg?1708312987",
      "slimcover": "https://assets.ppy.sh/beatmaps/2136372/covers/slimcover.jpg?1708312987"
    },
    "previewUrl": "https://b.ppy.sh/preview/2136372.mp3",
    "rarity": "Rare",
    "popularityScore": 85.73,
    "mode": 0
  },
  {
    "id": 10386,
    "beatmapsetId": 1018,
    "artist": "Caramell",
    "artistUnicode": "Caramell",
    "title": "Caramelldansen (Speedycake Remix)",
    "titleUnicode": "Caramelldansen (Speedycake Remix)",
    "version": "JAMES DIFFICULTY!",
    "creator": "MaxwellDemon",
    "creatorId": 4254,
    "stars": 3.24,
    "bpm": 164,
    "length": 172,
    "status": "ranked",
    "playcount": 1846312,
    "favouriteCount": 595,
    "rankedDate": "2008-05-04T00:34:16Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1018/covers/cover.jpg?1622019021",
      "card": "https://assets.ppy.sh/beatmaps/1018/covers/card.jpg?1622019021",
      "list": "https://assets.ppy.sh/beatmaps/1018/covers/list.jpg?1622019021",
      "slimcover": "https://assets.ppy.sh/beatmaps/1018/covers/slimcover.jpg?1622019021"
    },
    "previewUrl": "https://b.ppy.sh/preview/1018.mp3",
    "rarity": "Rare",
    "popularityScore": 85.72,
    "mode": 0
  },
  {
    "id": 244488,
    "beatmapsetId": 89799,
    "artist": "ParagonX9",
    "artistUnicode": "ParagonX9",
    "title": "Chaoz Fantasy",
    "titleUnicode": "Chaoz Fantasy",
    "version": "egg pain+++",
    "creator": "onlyforyou",
    "creatorId": 597858,
    "stars": 7.16,
    "bpm": 211,
    "length": 183,
    "status": "loved",
    "playcount": 1571337,
    "favouriteCount": 902,
    "rankedDate": "2019-09-02T20:52:42Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/89799/covers/cover.jpg?1622063884",
      "card": "https://assets.ppy.sh/beatmaps/89799/covers/card.jpg?1622063884",
      "list": "https://assets.ppy.sh/beatmaps/89799/covers/list.jpg?1622063884",
      "slimcover": "https://assets.ppy.sh/beatmaps/89799/covers/slimcover.jpg?1622063884"
    },
    "previewUrl": "https://b.ppy.sh/preview/89799.mp3",
    "rarity": "Rare",
    "popularityScore": 85.72,
    "mode": 0
  },
  {
    "id": 184241,
    "beatmapsetId": 57950,
    "artist": "SOUND HOLIC",
    "artistUnicode": "SOUND HOLIC",
    "title": "Drive My Life",
    "titleUnicode": "Drive My Life",
    "version": "Lunatic",
    "creator": "Scorpiour",
    "creatorId": 867259,
    "stars": 5.03,
    "bpm": 167,
    "length": 250,
    "status": "ranked",
    "playcount": 1460550,
    "favouriteCount": 766,
    "rankedDate": "2012-11-16T12:38:08Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/57950/covers/cover.jpg?1650613637",
      "card": "https://assets.ppy.sh/beatmaps/57950/covers/card.jpg?1650613637",
      "list": "https://assets.ppy.sh/beatmaps/57950/covers/list.jpg?1650613637",
      "slimcover": "https://assets.ppy.sh/beatmaps/57950/covers/slimcover.jpg?1650613637"
    },
    "previewUrl": "https://b.ppy.sh/preview/57950.mp3",
    "rarity": "Rare",
    "popularityScore": 85.72,
    "mode": 0
  },
  {
    "id": 3109226,
    "beatmapsetId": 1518924,
    "artist": "Hoshimachi Suisei",
    "artistUnicode": "星街すいせい",
    "title": "Kakero",
    "titleUnicode": "駆けろ",
    "version": "Shooting Star",
    "creator": "Amateurre",
    "creatorId": 7326908,
    "stars": 6.1,
    "bpm": 176,
    "length": 227,
    "status": "ranked",
    "playcount": 411495,
    "favouriteCount": 1091,
    "rankedDate": "2022-06-20T14:04:42Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1518924/covers/cover.jpg?1654831836",
      "card": "https://assets.ppy.sh/beatmaps/1518924/covers/card.jpg?1654831836",
      "list": "https://assets.ppy.sh/beatmaps/1518924/covers/list.jpg?1654831836",
      "slimcover": "https://assets.ppy.sh/beatmaps/1518924/covers/slimcover.jpg?1654831836"
    },
    "previewUrl": "https://b.ppy.sh/preview/1518924.mp3",
    "rarity": "Rare",
    "popularityScore": 85.72,
    "mode": 0
  },
  {
    "id": 199044,
    "beatmapsetId": 68891,
    "artist": "ONE OK ROCK",
    "artistUnicode": "ONE OK ROCK",
    "title": "The Beginning",
    "titleUnicode": "The Beginning",
    "version": "Dance",
    "creator": "tutuhaha",
    "creatorId": 546991,
    "stars": 5.68,
    "bpm": 182,
    "length": 109,
    "status": "ranked",
    "playcount": 3655516,
    "favouriteCount": 1816,
    "rankedDate": "2013-02-22T01:47:49Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/68891/covers/cover.jpg?1622060685",
      "card": "https://assets.ppy.sh/beatmaps/68891/covers/card.jpg?1622060685",
      "list": "https://assets.ppy.sh/beatmaps/68891/covers/list.jpg?1622060685",
      "slimcover": "https://assets.ppy.sh/beatmaps/68891/covers/slimcover.jpg?1622060685"
    },
    "previewUrl": "https://b.ppy.sh/preview/68891.mp3",
    "rarity": "Epic",
    "popularityScore": 92.66,
    "mode": 0
  },
  {
    "id": 3334672,
    "beatmapsetId": 1608572,
    "artist": "Ando Hirokazu",
    "artistUnicode": "安藤浩和",
    "title": "Gourmet Race",
    "titleUnicode": "プププランドステージ",
    "version": "Cris' Grand Prix",
    "creator": "gary00737",
    "creatorId": 6029467,
    "stars": 6.64,
    "bpm": 187,
    "length": 69,
    "status": "ranked",
    "playcount": 2237724,
    "favouriteCount": 1853,
    "rankedDate": "2022-01-21T01:42:37Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1608572/covers/cover.jpg?1645787270",
      "card": "https://assets.ppy.sh/beatmaps/1608572/covers/card.jpg?1645787270",
      "list": "https://assets.ppy.sh/beatmaps/1608572/covers/list.jpg?1645787270",
      "slimcover": "https://assets.ppy.sh/beatmaps/1608572/covers/slimcover.jpg?1645787270"
    },
    "previewUrl": "https://b.ppy.sh/preview/1608572.mp3",
    "rarity": "Epic",
    "popularityScore": 92.66,
    "mode": 0
  },
  {
    "id": 2317225,
    "beatmapsetId": 1108809,
    "artist": "Yorushika",
    "artistUnicode": "ヨルシカ",
    "title": "Aruku",
    "titleUnicode": "歩く",
    "version": "Extreme",
    "creator": "Faito",
    "creatorId": 9706291,
    "stars": 6.67,
    "bpm": 200,
    "length": 186,
    "status": "ranked",
    "playcount": 1682766,
    "favouriteCount": 2015,
    "rankedDate": "2020-07-13T20:45:22Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/1108809/covers/cover.jpg?1650693509",
      "card": "https://assets.ppy.sh/beatmaps/1108809/covers/card.jpg?1650693509",
      "list": "https://assets.ppy.sh/beatmaps/1108809/covers/list.jpg?1650693509",
      "slimcover": "https://assets.ppy.sh/beatmaps/1108809/covers/slimcover.jpg?1650693509"
    },
    "previewUrl": "https://b.ppy.sh/preview/1108809.mp3",
    "rarity": "Epic",
    "popularityScore": 92.66,
    "mode": 0
  },
  {
    "id": 169505,
    "beatmapsetId": 55644,
    "artist": "Avicii",
    "artistUnicode": "Avicii",
    "title": "Levels (Nightcore Mix)",
    "titleUnicode": "Levels (Nightcore Mix)",
    "version": "Insane",
    "creator": "Kiyro",
    "creatorId": 1474421,
    "stars": 4.34,
    "bpm": 141,
    "length": 93,
    "status": "ranked",
    "playcount": 8904895,
    "favouriteCount": 3233,
    "rankedDate": "2013-03-30T18:09:01Z",
    "covers": {
      "cover": "https://assets.ppy.sh/beatmaps/55644/covers/cover.jpg?1650613207",
      "card": "https://assets.ppy.sh/beatmaps/55644/covers/card.jpg?1650613207",
      "list": "https://assets.ppy.sh/beatmaps/55644/covers/list.jpg?1650613207",
      "slimcover": "https://assets.ppy.sh/beatmaps/55644/covers/slimcover.jpg?1650613207"
    },
    "previewUrl": "https://b.ppy.sh/preview/55644.mp3",
    "rarity": "Legendary",
    "popularityScore": 95.01,
    "mode": 0
  }
];

export const SEED_DATASET_INFO: DatasetInfo = {
  totalMaps: 100,
  lastUpdated: new Date().toISOString(),
  version: '1.0.0-seed',
  source: 'Bundled offline fallback seed dataset',
  rarityCounts: {
    Common: 31,
    Uncommon: 29,
    'Uncommon+': 26,
    Rare: 10,
    Epic: 3,
    Legendary: 1,
    Mythic: 0,
    Celestial: 0,
    Divine: 0,
    GOAT: 0,
    EX: 0,
  },
};
